<template>
  <div class="guiding">
    <div class="body">
      <h1>接口调用过程</h1>
      <h2>1、获取权限</h2>
      <p>开发者注册后登录到资源开放平台，进入【开发者】获取自己的Client Id和Client Secret。</p>
      <h2>2、确定接口参数</h2>
      <p>查看开发文档，根据调用的不同的接口确定所需要的参数。</p>
      <h2>3、获取临时Token</h2>
      <p>根据文档要求，通过注册用户账户密码和开发者自己的Client Id和Client Secret获取临时Token。</p>
      <h2>4、发起接口需求</h2>
      <p>根据接口所需的参数，将参数一起和Token提交到接口的请求地址中。</p>
      <h2>5、解析返回的数据</h2>
      <p>采用HTTP请求向服务器发起请求后获取响应数据，并对数据进行解析处理。</p>
    </div>
  </div>
</template>
<script type="text/babel">

  export default {
    components: {
    },
    data: function() {
      return {
      };
    },
    name: 'guiding',
    async mounted() {
    },
    methods: {

    }
  }
</script>
<style scoped>




</style>
<style>
  .guiding{
    background: #F7F7F7;
    overflow: hidden;
  }
  .guiding .body{
    width: 1200px;
    height: 728px;
    margin: 60px auto;
    padding: 30px 60px;
    background: #FFFFFF;
    /*border-radius: 12px;*/
    box-shadow:0px 5px 10px 0px rgba(0, 0, 0, 0.08);
  }

  .guiding .body h1{
    font-size:24px;
    font-family:MicrosoftYaHei-Bold;
    font-weight:bold;
    color:#333333;
    margin: 35px;
  }

  .guiding .body h2{
    font-size:18px;
    font-family:MicrosoftYaHei-Bold;
    font-weight:bold;
    color:#333333;
    margin: 20px 55px;
  }

  .guiding .body p{
    font-size:14px;
    font-family:MicrosoftYaHei-Bold;
    font-weight:600;
    color:#333333;
    margin: 20px 85px;
  }

</style>




// WEBPACK FOOTER //
// src/pages/front/guide/index.vue